var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-card',{attrs:{"no-body":"","border-variant":"msstream","bg-variant":"msstream","text-variant":"light"}},[_c('b-card-body',[_c('b-row',{staticClass:"justify-content-center text-center",staticStyle:{"margin-bottom":"30px"}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }